<template>
  <commonTable
    :fields="currentRepairDeviceTableFields"
    :items="currentRepairDeviceTableItems"
    :otherTheme="'tbody-green'"
    stickyHeader="450px"
  >
    <template #header>當前報修機台</template>
  </commonTable>
  <div class="text-end mt-3">
    <button
      type="button"
      class="btn p-0"
      style="
        color: #fff;
        background-color: #4b8c80;
        width: 7rem;
        height: 2rem;
        font-size: 1.125rem;
      "
      @click="addRepairOrder"
    >
      新增報修單
    </button>
  </div>
</template>

<script>
import commonTable from "@/components/commonTable.vue";
import { computed, inject, ref } from "vue";
import store from "@/store";
export default {
  components: {
    commonTable,
  },
  setup() {
    const add = inject("add");
    const commonMethods = inject("commonMethods");
    const currentRepairDeviceTableFields = inject("currentRepairDeviceTableFields");
    const currentRepairDeviceTableItems = inject("currentRepairDeviceTableItems");

    //getters
    const loginData = computed(() => store.getters["getLogin/get_loginData"]);

    const addRepairOrder = commonMethods.addRepairOrder;
    const account = ref(loginData.value.account);
    const username = ref(loginData.value.username);

    return {
      add,
      currentRepairDeviceTableFields,
      currentRepairDeviceTableItems,
      addRepairOrder,
      account,
      username,
    };
  },
};
</script>

<style></style>
